import { cn } from '@mgrvtechgroup/admin-ds';
import { useState, type ComponentProps } from 'react';

/**
 * 사진 자리 표시 — 내려받는 동안 이미지 칸이 스켈레톤으로 깜빡이고, 받으면(또는 실패하면) 멈춘다.
 * 칸 크기(aspect-ratio·높이)는 부르는 쪽이 정한다. 크기가 없는 이미지는 칸이 0이라 자리 표시도 보이지 않고,
 * 받아지는 순간 아래 내용이 밀린다. 주소(src)가 바뀌면 다시 자리 표시로 돌아간다.
 */
export function LoadingImg({
  className,
  src,
  alt,
  onLoad,
  onError,
  ...props
}: ComponentProps<'img'>) {
  const [settledSrc, setSettledSrc] = useState<string | undefined>(undefined);
  const settled = src !== undefined && settledSrc === src;
  return (
    <img
      {...props}
      src={src}
      alt={alt}
      className={cn(className, !settled && 'bg-skeleton animate-pulse')}
      onLoad={(event) => {
        setSettledSrc(src);
        onLoad?.(event);
      }}
      onError={(event) => {
        setSettledSrc(src);
        onError?.(event);
      }}
    />
  );
}
